<template>
  <BasePage title="Manage">
    <h1 class="title is-1">Manage</h1>

    <OrgManage v-if="isGroupAdmin" />

    <div class="columns is-desktop">

      <section class="column is-two-thirds is-offset-2">

        <div class="flex-space-between">
          <h2 class="title is-2">Groups</h2>
        <section>
          <input
            class="button is-primary"
            type='button'
            name='Add Team'
            @click='showGetUserInput = true'
            value="+ Add Group"/>

        </section>
        </div>

        <ul v-if="teams.length > 0 && !loading">
          <li class="box" v-for="team in teams">

            <div class="flex-space-between">
              <div class="flex-align-center">
                <span class="tag is-info user-count" v-if="is_admin">{{ team.group.name }}</span>
                <router-link class="title is-3" :to="'/groups/' + team.id" >{{ team.name }}</router-link>
                <span class="tag is-medium">{{ team.privacy_setting == 'public' ? 'open' : team.privacy_setting }}</span>
                <span class="tag is-medium user-count">{{ team.members.length }} members</span>
              </div>

              <input
                class='button'
                :class="{ 'is-active': team.expanded }"
                type='button'
                :value="team.expanded ? 'collapse' : 'expand'"
                @click="toggleTeam(team.id)"
                />
            </div>

            <section v-show="team.expanded">

              <section class="columns">
                <GroupUserSearch v-if="editing" :team="team"/>

                <TeamMemberList @editing="editing = !editing" :editing="editing" :team="team" />
              </section>

            <input
              class="button is-danger"
              type='button'
              name='Delete Team'
              @click='deleteTeam(team.id)'
              value="Delete Team"
              v-if="team.members.length==0"
            />

            </section>
          </li>
        </ul>
        <p v-if="teams.length === 0 && !loading">No teams.</p>

        <Loader v-if="loading"/>

      </section>

      <Confirm
        @cancel="showDelete = false"
        @confirm="removeActiveTeam"
        title="Deleting Team"
        message="Are you sure you want to delete this team?"
        :show="showDelete"
        :loading="deleting"
      />

      <GetUserInput
        @cancel="showGetUserInput = false"
        @confirm="addTeam"
        title="Create New Team"
        message="What should this team be called?"
        :show="showGetUserInput"
        :loading="deleting"
      />

    </div>
  </BasePage>
</template>

<script>
import BasePage from './BasePage.vue'
import MyGroups from './MyGroups.vue'
import GroupUserSearch from './GroupUserSearch.vue'
import TeamMemberList from './TeamMemberList.vue'
import Confirm from './Confirm.vue'
import GetUserInput from './GetUserInput.vue'
import OrgManage from './OrgManage.vue'

import store from '../store.js'

import Loader from './Loader.vue'

export default {
  name: 'manage',
  components: {
    BasePage,
    MyGroups,
    Loader,
    GroupUserSearch,
    TeamMemberList,
    Confirm,
    GetUserInput,
    OrgManage,
  },
  mounted () {
    store.dispatch('fetchTeams')
  },
  methods: {
    toggleTeam (id) {
      store.commit('toggleTeam', id)
    },
    showModal () {
      store.commit('setShowCreateCycleModal', true)
    },
    addTeam () {
      this.showGetUserInput = false
      store.dispatch('addTeam', { name: this.userInput })
    },
    deleteTeam (teamID) {
      this.showDelete = true
      this.activeTeamID = teamID
    },
    removeActiveTeam () {
      this.deleting = true
      store.dispatch('deleteTeamByID', this.activeTeamID)
        .then(() => {
          this.deleting = false
        })
      this.showDelete = false
    },
  },
  computed: {
    teams () {
      return store.state.teams
    },
    loading () {
      return store.state.loadingTeamData
    },
    is_admin () {
      return store.state.user.is_admin
    },
    isPro () {
      return store.state.user.is_pro
    },
    isGroupAdmin () {
      return store.state.user.is_group_admin
    },
    userInput () {
      return store.state.userInput
    },
  },
  data () {
    return {
      activeTeamID: null,
      query: '',
      editing: false,
      deleting: false,
      showDelete: false,
      showGetUserInput: false,
      userText: null,
    }
  },
}

</script>

<style lang="scss" scoped>

.title.team {
  margin-bottom: 0;
}

a.title {
  color: #23c6c8;
}

a.title:not(:last-child) {
  margin-bottom: 0;
}

.user-count {
  margin-left: 5px;
  margin-right: 5px;
}

ul.team-list {
  margin-top: 0.5rem;
}

</style>



// WEBPACK FOOTER //
// Manage.vue?21bda312